var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.513,
    height: 15.864,
    viewBox: "0 0 18.513 15.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eye-off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#768092;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.508,7.838a4.2,4.2,0,0,1,4.21,4.177,4.018,4.018,0,0,1-.3,1.529l2.458,2.438a9.876,9.876,0,0,0,2.888-3.966A9.97,9.97,0,0,0,8.15,6.334L9.967,8.14A4.162,4.162,0,0,1,11.508,7.838ZM3.093,5.562l1.921,1.9.388.384A9.829,9.829,0,0,0,2.25,12.015a9.984,9.984,0,0,0,12.943,5.561l.355.351,2.466,2.438,1.07-1.062L4.159,4.5Zm4.652,4.615L9.05,11.47a2.367,2.367,0,0,0-.066.541,2.512,2.512,0,0,0,2.524,2.5,2.374,2.374,0,0,0,.545-.066l1.306,1.293A4.188,4.188,0,0,1,7.3,12.007,4.127,4.127,0,0,1,7.745,10.176Zm3.627-.649,2.652,2.632.017-.132a2.512,2.512,0,0,0-2.524-2.5Z",
    transform: "translate(-2.25 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.b5441110d38210309476f58040024fca.svg";
export { ForwardRef as ReactComponent };